<div class="patient-form-wrapper">
  <a class="close" (click)="closeModal()">&times;</a>
  <h1>{{ patientId ? 'Edit Patient' : 'Add New Patient' }}</h1>

  <label>Patient ID</label>
  <input (change)="handlePatientChange()" [(ngModel)]="name" type="text" class="form-input">
  
  <label>Postal Code</label>
  <app-places-autocomplete class="auto-input form-input" [formatedAddress]="patientAddress?.street" [placeholder]="''" (addressChanged)="getAddress($event)"></app-places-autocomplete>

  <div class="error" *ngIf="errMsg">
    {{errMsg}}
  </div>
  <br>
  
  <div class="form-actions">
    <button class="btn" (click)="addNewPatient()" *ngIf="!patientId">Save</button>
    <button class="btn" (click)="updatePatient()" *ngIf="patientId">Update</button>
  </div>
</div>